const sessionRules = {
  email: ["required", "trim", "email"],
  password: ["required", "trim", "string"],
};

export default sessionRules;
